import React from "react";
import { Button, Card, Typography } from "antd";
import { AndroidOutlined, DownloadOutlined } from "@ant-design/icons";
import logo from "../logo.png"; // Assuming logo is available here

const { Title, Text } = Typography;

const DescargarAppPage = () => {
    const handleDownload = () => {
        // START_URL_PLACEHOLDER
        // Replace with the actual URL of the APK file
        const apkUrl = "https://backapp.sidelsur.com/download/app";
        // END_URL_PLACEHOLDER
        const link = document.createElement("a");
        link.href = apkUrl;
        link.download = "interpack-app.apk";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                backgroundColor: "#f0f2f5",
                padding: "20px",
            }}
        >
            <Card
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    textAlign: "center",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
            >
                <div style={{ marginBottom: "24px" }}>
                    <Title level={3} style={{ marginBottom: "8px" }}>
                        Descargar Aplicación
                    </Title>
                    <Text type="secondary">
                        Obtén la última versión de nuestra aplicación para Android.
                    </Text>
                </div>

                <div style={{ marginBottom: "32px" }}>
                    <AndroidOutlined style={{ fontSize: "64px", color: "#3DDC84", marginBottom: "16px" }} />
                    <br />
                    <Text strong>Versión 1.0.0</Text>
                </div>

                <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    size="large"
                    block
                    onClick={handleDownload}
                    style={{
                        height: "48px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        backgroundColor: "#1890ff",
                    }}
                >
                    Descargar APK
                </Button>

                <div style={{ marginTop: "24px" }}>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                        © {new Date().getFullYear()} Interpack S.A.S.
                    </Text>
                </div>
            </Card>
        </div>
    );
};

export default DescargarAppPage;
